import * as members from 'privates/privateMembers';
import {validate} from 'privates/validations/validation';
import {emptyStringIfNil} from '../../privates/utils';

/**
 * @mixin LabelMixin
 * @description Provides functionality for elements that have a label.
 * @memberof $w
 */
class LabelMixin {
    /**
     * @member label
     * @label property
     * @syntax
     * get label(): string
     * set label(value: string): void
     * @summary Sets or gets the label of an element.
     * @type {external:String}
     * @default Empty string
     * @memberof $w.LabelMixin
     * @instance
     */
    get label() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        return RMI.getData(compId).label;
    }

  /**
   * @member label
   * @memberof $w.LabelMixin
   * @param {external:String} value
   */
    set label(value) {
        const compType = members._type.get(this).compType;
        const isValid = validate({
            compType,
            functionName: 'label',
            dataToValidate: {label: value},
            compName: this.id
        });
        if (!isValid) {
            return;
        }
        const label = emptyStringIfNil(value);
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        RMI.setData(compId, {label});
    }

}

export default LabelMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/LabelMixin.es6